// ReSharper disable InconsistentNaming

export interface EnumDescription {
    IntValue: number;
    Name: string;
    LocKey: string;
    Description: string;
}

export interface IEnumDescriptionWithDataType extends EnumDescription {
    DataType: string;
    LocParams?: string[];
}

export class IEnumDescriptionWithDataType {
    private static _properties = ["DataType"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value));
    }
}

/**
 * Rozhraní reprezentující enum.
 */
export interface IEnum {

    /**
     * Vrací instanci typu daného enumu.
     */
    getType(): IEnumType;

    /**
     * Vrací název enumu.
     */
    getTypeName(): string;

    /**
     * Vrací stringovou reprezentaci instance.
     */
    toString(): string;

    /**
     * Vrací lokalizovanou stringovou reprezentaci instance.
     */
    toLocaleString(): string;

    /**
     * Vrací lokalizovanou stringovou reprezentaci názvu popisku enumu.
     */
    getLocalizedName(): Promise<string>;

    /**
     * Vrací název popisku enumu.
     */
    getName(): string;

    /**
     * Vrací číselnou reprezentaci popisku enumu.
     */
    valueOf(): number;

    /**
     * Vrací číselnou reprezentaci popisku enumu využitelnou pro JSON.
     */
    toJSON(): number;
}

export class IEnum {
    private static _methods: (keyof IEnum)[] = ["getType", "getTypeName", "toString", "toLocaleString", "getLocalizedName", "getName", "valueOf", "toJSON"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && this._methods.every(value => typeof instance[value] === "function");
    }
}

/**
 * Rozhraní obsahující detailní informace enumu, které slouží k vytvoření enumu.
 */
export interface IEnumType {

    /**
     * Doplňující údaje k enumu.
     */
    descriptions: EnumDescription[];

    /**
     * Typ enumu. Obvykle se používá k držení údaje o názvu enumu.
     */
    type: string;
}

export class IEnumType {
    private static _properties: (keyof IEnumType)[] = ["descriptions", "type"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && this._properties.every((value) => Reflect.has(instance, value));
    }
}

// ReSharper restore InconsistentNaming
